<template>
    <div class="lines-grid">
        <loading-overlay v-if="$asyncComputed.ecgData.updating"></loading-overlay>
        <error-overlay v-else-if="$asyncComputed.ecgData.error"></error-overlay>
        <div class="controls">
            <div class="text-button" v-if="selectedLines.length > 0" @click="selectedLines = []">Unselect All</div>
            <div class="text-button" v-if="selectedLines.length == 0" @click="selectedLines = lineOptions">Select All</div>
            <multi-select-component mode="multiple" v-model="selectedLines"  label="lead" :options="lineOptions" :configurationOptions="{'allow-empty': true, 'label-inside':true}"/>
            <div></div>
        </div>
        <div class="grid-container">
            <div class="grid-plot" v-for="item in gridLayout" :key="item.id">
                <line-chart
                    :currentTime="currentTime"
                    :actualCurrentTime="actualCurrentTime"
                    :showECG="false"
                    :lineData="item.data"
                    :config="{ dataSource: 'linedata', lineId: `time-${item.leadName}`, legend: 'Lead', isSingleVarPlot: true, units: 'mV' }"
                    :style="{height: '350px'}"
                ></line-chart>
            </div>
        </div>
    </div>
  </template>

  <script>
    import VueGridLayout from 'vue-grid-layout'
    import widgetContent from '@/mixins/widgetContent'
    import MultiSelectComponent from '@/components/MultiSelectComponent'
    import LineChart from './LineChart.vue'
    import ApolloAPI from '@/api/apollo_api'
    
    export default {
        name: "LinesGrid",
        components: {
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem,
            MultiSelectComponent,
            LineChart
        },
        mixins: [widgetContent],
        props: {
            currentTime: Number,
            actualCurrentTime: Number,
        },
        data() {
            return {
                selectedLines: []
            }
        },
        asyncComputed: {
            ecgData() {
                if (
                    this.$store.state.paramsData.project &&
                    this.$store.state.paramsData.trial &&
                    this.$store.state.paramsData.subject
                ) {
                    return ApolloAPI.getEcg(this.$store.state.paramsData)
                }
            },
        },
        computed: {
            lineOptions() {
                if (this.ecgData) {
                    let ecgDataKeys = Object.keys(this.ecgData[0])
                    let lineKeys = ecgDataKeys.filter(variable => variable.includes('V') || variable.includes('L'))
                    this.selectedLines = lineKeys
                    return lineKeys
                } else {
                    return []
                }
            },
            gridLayout() {
                let layout = []
                this.selectedLines.forEach((lead,i) => {
                    layout.push(
                        { data: this.extractLeadData(lead), leadName: lead }
                    )
                })
                return layout
            }
        },
        methods: {
            skip() {
                return Math.floor(this.ecgData.length/1500) || 1
            },
            extractLeadData(leadName) {
                return this.ecgData.filter((d,i)=>i%this.skip()===0).map((d,idx)=>({dt:d['Time'],value:d[leadName]}))
            }
        }
    }
  </script>
  
  <style lang="stylus" scoped>

    .lines-grid
        display: flex
        flex-direction: column
        .controls
            position: relative
            z-index: 2
            display: flex
            flex: 0 0 auto
            justify-content: flex-end
            align-items: center
            width: 100%
            margin-bottom: 15px

            .text-button
                margin-right: 10px
                color: $shuttle-gray
                m-font-size(12, 14)
            .text-button:hover
                color: red
                text-decoration: underline

        .grid-container
            display: flex
            flex-direction: row
            flex-wrap: wrap
            justify-content: center
            .grid-plot
                flex: 1 1 30%
  </style>